export default __webpack_public_path__ + "public/images/services/Filter@2x.png?d0ce8f4f";